import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import authReducer from "../features/auth/auth.slice";
import harvestlogReducer from "../features/harvest/harvest-log.slice";
import coreReducer from "./core-slice";
import payrollReducer from "../features/payroll/payroll.slice";
import cropTrackingReducer from "../features/crop-tracking/crop-tracking.slice";
import attendanceReducer from "../features/attendance/attendance.slice";
import usersReducer from "../features/users/users.slice";
import leaveReducer from "../features/leave/leave.slice";
import stockMarketReducer from "../features/stock-market/stock-market.slice";
import invoicingReducer from "../features/invoicing/invoicing.slice";
import voucherReducer from "../features/voucher/voucher.slice";
import productsReducer from "../features/products/products.slice";
import customersReducer from "../features/customers/customers.slice";
import { smePlusApi, rtkQueryErrorLogger } from "./api";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import searchFiltersReducer from "./search-filters.slice";

export const store = configureStore({
    reducer: {
        core: coreReducer,
        searchFilters: searchFiltersReducer,
        auth: authReducer,
        harvest: harvestlogReducer,
        payroll: payrollReducer,
        cropTracking: cropTrackingReducer,
        attendance: attendanceReducer,
        users: usersReducer,
        leave: leaveReducer,
        stockMarket: stockMarketReducer,
        invoicing: invoicingReducer,
        voucher: voucherReducer,
        products: productsReducer,
        customers: customersReducer,
        [smePlusApi.reducerPath]: smePlusApi.reducer, // Add the RTK Query reducer
    },
    // Add the RTK Query middleware
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(smePlusApi.middleware).concat(rtkQueryErrorLogger),
});

// This is required for refetchOnFocus and refetchOnReconnect to work
setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
